import ConditionRadioButton from './radio_button.js';

const AVAIABLE_CONDITION_FIELDS = { ConditionRadioButton };

const typed_field_comp = {
  props: {
    field: {
      type: Skylark.App.Model.Field.Base,
      required: true
    },
    judgements: Object
  },

  render: function(h) {
    return h(this._getComponent(), {
      props: {
        field: this.field,
        judgements: this.judgements
      },
      on: {
        judgementsChanged: this.judgementsChangedFunc
      }
    });
  },

  methods: {
    judgementsChangedFunc: function(judgements) {
      this.$emit('judgementsChanged', judgements);
    },

    _getComponent: function() {
      var type;

      type = `Condition${this.field.type.demodulize()}`;
      return AVAIABLE_CONDITION_FIELDS[type] || AVAIABLE_CONDITION_FIELDS[`${type}Field`];
    }
  }
};

const ConditionField = {
  props: {
    condition: {
      type: Skylark.App.Model.YetAnotherWorkflow.Condition,
      required: true
    },
    extendClass: {
      default: ''
    }
  },

  components: {
    'typed-field': typed_field_comp
  },

  computed: {
    field: function() {
      return this.condition.getFieldConditionable();
    }
  },

  template: `
    <div class="form-field" :class="extendClass">
      <div class="form-field-head">
        <div class="form-field-title justify-box">
          <span class="text-ellipsis content">{{ field.title }}</span>
          <div class="btn icon-btn head-icon" @click='removeCondition'>
            <i class="slp-trash"></i>
          </div>
        </div>
        <div class="form-field-description" v-if='field.description'>{{ field.description }}</div>
      </div>
      <div class="form-field-input-container">
        <div class="form-field-input">
          <typed-field :field='field'
                       :judgements='condition.judgements'
                       @judgementsChanged='judgementsChangedFunc' />
        </div>
      </div>
    </div>
  `,

  methods: {
    judgementsChangedFunc: function(judgements) {
      this.condition.judgements = judgements;
    },

    removeCondition: function() {
      this.$emit('removeCondition', this.condition);
    }
  }
};

export default ConditionField;
